import classNames from 'classnames';
import React, { useState } from 'react';
import { contextMenu } from 'react-contexify';
import {
  CUSTOM_COLUMNS,
  CUSTOM_COLUMN_KEY,
  STATUS_FILTER_MENU_ID,
} from '../../../../common/constants';
import { FieldEntity } from '../../../../common/types/EntityTypes';
import { CustomHeaderParams } from '../../../../common/types/dashboard/DashboardUITypes';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import {
  selectShowDocName,
  selectShowNotes,
  selectShowStatus,
  selectShowUploadedDate,
  toggleDocName,
  toggleNotes,
  toggleStatus,
  toggleUploadedDate,
} from '../../../../redux/reducers/dashboardSlice';
import { selectMenu, setMenu } from '../../../../redux/reducers/popupSlice';
import { selectResolutionMetadata } from '../../../../redux/reducers/uiSlice';
import CollapseLeftArrow from '../../../../assets/images/dashboard/table/CollapseLeft.svg';
import CollapseRightArrow from '../../../../assets/images/dashboard/table/CollapseRight.svg';
import bellIcon from '../../../../assets/images/dashboard/table/bellIcon.svg';
import ApSettingsIcon from '../../../../assets/images/dashboard/header/ap_settings_icon.svg';
import ApDoneIcon from '../../../../assets/images/dashboard/header/ap_done_icon.svg';
import ApNotesPenIcon from '../../../../assets/images/dashboard/header/ap_notes_pen_icon.svg';
import ApDocLeaseIcon from '../../../../assets/images/dashboard/header/ap_doc_icon.svg';

function TableHeader(props: CustomHeaderParams) {
  const dispatch = useAppDispatch();
  const [menuActive, setMEnuActive] = useState(false);
  const showNotes = useAppSelector(selectShowNotes);
  const showUploadedDate = useAppSelector(selectShowUploadedDate);
  const showDocName = useAppSelector(selectShowDocName);
  const showStatus = useAppSelector(selectShowStatus);
  const dashboardData = useAppSelector(selectResolutionMetadata);

  const selectedMenu = useAppSelector(selectMenu);
  const [editHeaderText, setEditHeaderText] = useState(false);

  function displayMenu(e: React.MouseEvent<HTMLElement>) {
    if (!menuActive) {
      setMEnuActive(true);
      if (e.currentTarget.offsetParent != null && e.currentTarget.offsetParent != undefined) {
        let parentDoc = e.currentTarget.offsetParent?.getBoundingClientRect();
        dispatch(setMenu(STATUS_FILTER_MENU_ID));
        contextMenu.show({
          id: selectedMenu,
          event: e,
          position: {
            x: parentDoc.left + parentDoc.width + 5,
            y: parentDoc.top + 10,
          },
        });
      }
    } else {
      setMEnuActive(false);
    }
  }

  function handleDocNameVisiblity() {
    const docNameVisibility = !showDocName;
    props.columnApi
      .getColumns()
      ?.filter(
        (col) =>
          col.isPinnedLeft() &&
          (col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.DOCUMENT_NAME ||
            col.getColDef().cellRendererParams.customData.code ==
              CUSTOM_COLUMN_KEY.DOCUMENT_HIDDEN),
      )
      .forEach((col) => {
        if (col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.DOCUMENT_NAME) {
          if (docNameVisibility) {
            props.columnApi.setColumnVisible(col.getColId(), true);
          } else {
            props.columnApi.setColumnVisible(col.getColId(), false);
          }
        } else if (
          col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.DOCUMENT_HIDDEN
        ) {
          if (docNameVisibility) {
            props.columnApi.setColumnVisible(col.getColId(), false);
          } else {
            props.columnApi.setColumnVisible(col.getColId(), true);
          }
        }
      });
    dispatch(toggleDocName());
  }

  function handleNotesVisiblity() {
    const newNotesVisibility = !showNotes;
    props.columnApi
      .getColumns()
      ?.filter(
        (col) =>
          col.isPinnedRight() &&
          (col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.NOTES ||
            col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.NOTES_HIDDEN),
      )
      .forEach((col) => {
        if (col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.NOTES) {
          if (newNotesVisibility) {
            props.columnApi.setColumnVisible(col.getColId(), true);
          } else {
            props.columnApi.setColumnVisible(col.getColId(), false);
          }
        } else if (
          col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.NOTES_HIDDEN
        ) {
          if (newNotesVisibility) {
            props.columnApi.setColumnVisible(col.getColId(), false);
          } else {
            props.columnApi.setColumnVisible(col.getColId(), true);
          }
        }
      });
    dispatch(toggleNotes());
  }

  function handleStatusVisiblity() {
    const statusVisibility = !showStatus;
    props.columnApi
      .getColumns()
      ?.filter(
        (col) =>
          col.isPinnedLeft() &&
          (col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.STATUS ||
            col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.STATUS_HIDDEN),
      )
      .forEach((col) => {
        if (col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.STATUS) {
          if (statusVisibility) {
            props.columnApi.setColumnVisible(col.getColId(), true);
          } else {
            props.columnApi.setColumnVisible(col.getColId(), false);
          }
        } else if (
          col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.STATUS_HIDDEN
        ) {
          if (statusVisibility) {
            props.columnApi.setColumnVisible(col.getColId(), false);
          } else {
            props.columnApi.setColumnVisible(col.getColId(), true);
          }
        }
      });
    dispatch(toggleStatus());
  }

  function handleUploadedDateVisiblity() {
    const uploadedDateVisibility = !showUploadedDate;
    props.columnApi
      .getColumns()
      ?.filter(
        (col) =>
          col.isPinnedLeft() &&
          (col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.REMINDER ||
            col.getColDef().cellRendererParams.customData.code ==
              CUSTOM_COLUMN_KEY.REMINDER_HIDDEN),
      )
      .forEach((col) => {
        if (col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.REMINDER) {
          if (uploadedDateVisibility) {
            props.columnApi.setColumnVisible(col.getColId(), true);
          } else {
            props.columnApi.setColumnVisible(col.getColId(), false);
          }
        } else if (
          col.getColDef().cellRendererParams.customData.code == CUSTOM_COLUMN_KEY.REMINDER_HIDDEN
        ) {
          if (uploadedDateVisibility) {
            props.columnApi.setColumnVisible(col.getColId(), false);
          } else {
            props.columnApi.setColumnVisible(col.getColId(), true);
          }
        }
      });
    dispatch(toggleUploadedDate());
  }

  // const handleSave = (editTextPayload: EditTextPayload) => {
  //   let requestPayload = {} as FieldUpdatePayload;
  //   requestPayload.code = props.customData.code;
  //   requestPayload.name =
  //     editTextPayload.value !== ""
  //       ? editTextPayload.value
  //       : props.customData.name;
  //   requestPayload.order = props.customData.order;
  //   requestPayload.isPinned = props.customData.pinned;
  //   requestPayload.isVisible = props.customData.visible;
  //   requestPayload.widthChange = props.customData.widthChange;
  //   if (editTextPayload.value !== "") {
  //     updateFieldMetadata(
  //       mapFieldUpdatePayloadToOfflineFieldUpdate(requestPayload, false)
  //     ).then(() => {
  //       dispatch(updateFieldAttribute(requestPayload));
  //     });
  //   }
  //   setEditHeaderText(false);
  // };

  function getHeader(header: FieldEntity) {
    if (header.code == CUSTOM_COLUMNS.PIN.key) {
      return <div className='th-compare'>{/*<img src={CompareTick} alt="Tick" />*/}</div>;
    } else if (header.code == CUSTOM_COLUMNS.REMINDER_HIDDEN.key) {
      return (
        <div style={{ flexShrink: 0 }} className='flex reminder-date-hidden'>
          <div className='col-header-image-container'>
            <img
              width={dashboardData.image_dimension.NOTES.widthPX}
              height={dashboardData.image_dimension.NOTES.heightPX}
              src={CollapseRightArrow}
              onClick={handleUploadedDateVisiblity}
            />
            <img src={bellIcon} />
          </div>
        </div>
      );
    } else if (header.code == CUSTOM_COLUMNS.REMINDER.key) {
      return (
        <div className='notes-values-text'>
          {showUploadedDate && <div className='flex fit-container header-text'>{header.name}</div>}
          {/* <div className='image-container'> */}
          <img
            className='img-no-shirnk'
            width={dashboardData.image_dimension.NOTES.widthPX}
            height={dashboardData.image_dimension.NOTES.heightPX}
            src={CollapseLeftArrow}
            onClick={handleUploadedDateVisiblity}
          />
          {/* </div> */}
        </div>
      );
    } else if (header.code == CUSTOM_COLUMNS.NOTES_HIDDEN.key) {
      return (
        <div style={{ flexShrink: 0 }} className='flex notes-hidden'>
          <div className='col-header-image-container'>
            <img
              width={dashboardData.image_dimension.NOTES.widthPX}
              height={dashboardData.image_dimension.NOTES.heightPX}
              src={CollapseLeftArrow}
              onClick={handleNotesVisiblity}
            />
            <img src={ApNotesPenIcon} className="col-img-pad-left" />
          </div>
        </div>
      );
    } else if (header.code == CUSTOM_COLUMNS.DOCUMENT_HIDDEN.key) {
      return (
        <div style={{ flexShrink: 0 }} className='flex notes-hidden'>
          <div className='col-header-image-container'>
            <img
              width={dashboardData.image_dimension.NOTES.widthPX}
              height={dashboardData.image_dimension.NOTES.heightPX}
              src={CollapseRightArrow}
              onClick={handleDocNameVisiblity}
            />
            <img src={ApDocLeaseIcon}  className="col-img-pad-left" />
          </div>
        </div>
      );
    } else if (header.code == CUSTOM_COLUMNS.DOCUMENT.key) {
      return (
        <div className='notes-values-text'>
          {showDocName && <div className='flex fit-container header-text'>{header.name}</div>}
          <img
            className='img-no-shirnk'
            width={dashboardData.image_dimension.NOTES.widthPX}
            height={dashboardData.image_dimension.NOTES.heightPX}
            src={CollapseLeftArrow}
            onClick={handleDocNameVisiblity}
          />
        </div>
      );
    } else if (header.code == CUSTOM_COLUMNS.NOTES.key) {
      return (
        <div className='notes-values-text'>
          {/* <div className='image-container'> */}
          <img
            className='img-no-shirnk'
            width={dashboardData.image_dimension.NOTES.widthPX}
            height={dashboardData.image_dimension.NOTES.heightPX}
            src={CollapseRightArrow}
            onClick={handleNotesVisiblity}
          />
          {/* </div> */}
          {showNotes && <div className='flex fit-container header-text'>{header.name}</div>}
        </div>
      );
    } else if (header.code == CUSTOM_COLUMNS.STATUS.key) {
      return (
        <div className='col-status-header'>
          <div className='col-status-sub-header header-text'>
            <div className='col-status-header-holder'>
              <div>Status</div>
              <img src={ApSettingsIcon} alt='Settings' />
            </div>
            <div>Author</div>
          </div>
          <div>
            <img
              className='img-no-shirnk col-status-img'
              width={dashboardData.image_dimension.NOTES.widthPX}
              height={dashboardData.image_dimension.NOTES.heightPX}
              src={CollapseLeftArrow}
              onClick={handleStatusVisiblity}
            />
          </div>
        </div>
      );
    } else if (header.code == CUSTOM_COLUMNS.STATUS_HIDDEN.key) {
      return (
        <div style={{ flexShrink: 0 }} className='flex status-hidden'>
          <div className='col-header-image-container'>
            <img
              width={dashboardData.image_dimension.NOTES.widthPX}
              height={dashboardData.image_dimension.NOTES.heightPX}
              src={CollapseRightArrow}
              onClick={handleStatusVisiblity}
            />
            <img src={ApDoneIcon} alt='Done' className="col-img-pad-left" />
          </div>
        </div>
      );
    } else if (header.code == CUSTOM_COLUMNS.CHILDREN.key) {
      return (
        // <img
        //   className={classNames(
        //     isReadOnly ? "visible-hidden" : "visibilty-not-hiddent",
        //     "img-no-shirnk"
        //   )}
        //   width={dashboardData.image_dimension.SETTINGS.widthPX}
        //   height={dashboardData.image_dimension.SETTINGS.heightPX}
        //   src={dashboardData.image_dimension.SETTINGS.image}
        //   onClick={() => dispatch(setSettings(true))}
        // ></img>
        <span></span>
      );
    } else if (
      // header.code == CUSTOM_COLUMNS.MARKET.key ||
      // header.code == CUSTOM_COLUMNS.AUTHOR.key ||
      header.name == CUSTOM_COLUMNS.LOI_DATE.title
    ) {
      return <div className='flex fit-container header-text header-text-align'>{header.name}</div>;
    }

    return (
      <div className='flex' style={{ gap: '5px', alignItems: 'baseline' }}>
        {/* <EditText
          name={header.code}
          className='header-text header-no-padding-margin'
          inputClassName='header-text input-text'
          style={{ padding: '5px' }}
          onSave={handleSave}
          value={header.name}
          defaultValue={header.name}></EditText> */}
        {/* {editHeaderText ? (
          <EditText
            name={header.code}
            className="header-text header-no-padding-margin"
            inputClassName="header-text input-text"
            style={{ padding: "5px" }}
            onSave={handleSave}
            defaultValue={header.name}
            readonly={isReadOnly}
          ></EditText>
        ) : ( */}
        <div
          className='header-text header-no-padding-margin'
          onClick={() => setEditHeaderText(true)}>
          {props.customData.name}
        </div>
        {/* )} */}
        {/* <img
          className="img-no-shirnk"
          onClick={(e) => handleColumnPin(!header.pinned)}
          width={dashboardData.image_dimension.COLUMN_PIN.widthPX}
          src={
            header.pinned
              ? dashboardData.image_dimension.COLUMN_PIN.unpinnedImage
              : dashboardData.image_dimension.COLUMN_PIN.pinnedImage
          }
        ></img> */}
      </div>
    );
  }
  return (
    <>
      <div
        className={classNames(
          'flex-auto-justify-end',
          // "fit-container",
          'ag-cell-font-common',

          // {
          //   "flex-h-align-center":
          //     props.customData?.code == CUSTOM_COLUMNS.STATUS.key ||
          //     props.customData?.code == CUSTOM_COLUMNS.CHILDREN.key,
          // }
        )}>
        {getHeader(props.customData)}
      </div>
    </>
  );
}
export default TableHeader;
